export const PASSWORD_RECOVERY_FIELDS = {
  email: 'email',
} as const;

export type FormValues = {
  [PASSWORD_RECOVERY_FIELDS.email]: string;
};
